$(document).ready(function () {

    /*collectionsFilter open-close*/
    $('.collectionsPage .collectionsFilter .collectionsFilter__title').on('click', function() {
        $(this).toggleClass('active');
        $(this).siblings('.collectionsFilter__wrap').toggleClass('active');
    });

    /*collectionsFilter reset*/
    $('.collectionsFilter__btn_reset').on('click',function () {
        $('.collectionsFilter__checkbox input:checked').prop('checked', false);
    });

    /*collectionsFilter select*/
    $('.collectionsFilter__btn_select').on('click',function () {
        $(this).closest('.collectionsFilter').find('.collectionsFilter__title').removeClass('active');
        $(this).closest('.collectionsFilter__wrap').removeClass('active');
    });
});
